// ApprovedNotificationCard.js

import React, {useState} from 'react';
import {Card, Typography, Box, Avatar, Dialog} from '@mui/material';
import ProfilePage from "../Pages/Profile";
import TripDetailsModal from "./TripCard";
import {trips} from "../data/TripsData";

const ApprovedNotificationCard = ({profile}) => {
    const [isUserOpen, setIsUserOpen] = React.useState(false);
    const [isOpen, setIsOpen] = useState(false); // Controls modal open/close state

    return (
        <>
            <Card sx={{
                maxWidth: 400,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                p: 1,
                borderRadius: 3,
                boxShadow: 3,
                marginBottom: 2
            }}>

                <Box sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Avatar src={profile.image} alt={profile.title} sx={{ml: 2, cursor: "pointer"}}
                            onClick={(e) => {
                                setIsOpen(false)
                                setIsUserOpen(true);
                                e.stopPropagation();
                            }}/>
                    <Box sx={{flexGrow: 1}} onClick={() => setIsOpen(true)}>
                        <Typography variant="body2" sx={{paddingLeft: 1, font: 'inherit', fontSize: '0.8rem'}}>
                            בקשתך להצטרף לטיול של {profile.title} אושרה
                        </Typography>
                    </Box>
                </Box>
                <Dialog sx={{zIndex: 9999}} maxWidth="lg" onClose={() => setIsUserOpen(false)} open={isUserOpen}>
                    <ProfilePage profileId={profile.id} onClose={() => setIsUserOpen(false)}/>
                </Dialog>
            </Card>
            <TripDetailsModal
                isOpen={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
                trip={trips.find(trip => trip.id === 3)}
                compact={false}
                hideCancelButton={false}
            />
        </>
    );
};

export default ApprovedNotificationCard;
